import { useEffect } from "react";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import ML from "../img/ML_Trans.png";
import MLCourseDetail1 from "../components/MLCourseDetails1";
import MLCourseDetail2 from "../components/MLCourseDetails2";
import Formula from "../img/Formula-pana.png";
import Mental from "../img/Mental health-pana.png";

const MLPage = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["AI 人工智能：機器學習 理論到應用"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "近40小時的全攻略課程，帶你掌握資料科學套件（NumPy、Pandas、Matplotlib、Seaborn），由淺入深學習「機器學習」的數學原理、理論與程式應用，全面涵蓋監督式學習（回歸、分類）與非監督式學習（降維、聚類）等 AI 模型！",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={ML} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>{" "}
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/wilson-machine-learning/?couponCode=${process.env.REACT_APP_MACHINE_LEARNING_COUPON}`}
              >
                <span>{process.env.REACT_APP_MACHINE_LEARNING_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/wilson-machine-learning/?couponCode=${process.env.REACT_APP_MACHINE_LEARNING_COUPON}`}
              >
                <span className="hide">
                  https://www.udemy.com/course/wilson-machine-learning/
                </span>
              </a>
            </p>
            {/* <p style={{ fontSize: "5px", opacity: "0.9" }} target="_blank">
              Hiskio 平台課程連結
              (無法使用優惠碼)：https://hiskio.com/courses/1280/about
            </p> */}
          </div>
        </div>
        <MLCourseDetail1 img={Formula} />
        <MLCourseDetail2 img={Mental} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default MLPage;
